import React, { useState } from 'react';
import { Building2, Palette, Images, Sparkles, Radio, Landmark, MapPin } from 'lucide-react';
import BrandingManager from './BrandingManager';
import IconCustomizer from './IconCustomizer';
import SliderManager from './SliderManager';
import AppearanceManager from './AppearanceManager';
import StreamingManager from './StreamingManager';
import RekeningManager from './RekeningManager';
import LokasiManager from './LokasiManager';

const SUB_TABS = [
  { id: 'branding', label: 'Branding', icon: Building2 },
  { id: 'lokasi', label: 'Lokasi & Peta', icon: MapPin },
  { id: 'rekening', label: 'Rekening & Iuran', icon: Landmark },
  { id: 'appearance', label: 'Tampilan & PWA', icon: Sparkles },
  { id: 'streaming', label: 'Streaming', icon: Radio },
  { id: 'icons', label: 'Ikon', icon: Palette },
  { id: 'slider', label: 'Image Slider', icon: Images },
];

const SettingsManager = () => {
  const [tab, setTab] = useState('branding');

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-heading font-bold text-primary-dark">Pengaturan Masjid</h2>
        <p className="text-sm font-body text-text-secondary mt-1">
          Kelola identitas, ikon, dan tampilan aplikasi secara mandiri
        </p>
      </div>

      <div className="bg-white rounded-2xl border border-stone-200 p-2 mb-6 flex gap-2 overflow-x-auto">
        {SUB_TABS.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              data-testid={`settings-subtab-${item.id}`}
              onClick={() => setTab(item.id)}
              className={`flex items-center gap-2 px-4 py-2 rounded-xl font-body font-medium text-sm transition-colors whitespace-nowrap ${
                tab === item.id ? 'bg-emerald-700 text-white' : 'text-stone-600 hover:bg-stone-50'
              }`}
            >
              <Icon className="w-4 h-4" />
              {item.label}
            </button>
          );
        })}
      </div>

      {tab === 'branding' && <BrandingManager />}
      {tab === 'lokasi' && <LokasiManager />}
      {tab === 'rekening' && <RekeningManager />}
      {tab === 'appearance' && <AppearanceManager />}
      {tab === 'streaming' && <StreamingManager />}
      {tab === 'icons' && <IconCustomizer />}
      {tab === 'slider' && <SliderManager />}
    </div>
  );
};

export default SettingsManager;
